<template>
  <div class="text-sm">
    <div>{{value + 1}} {{$t('of')}} {{max}}</div>
    <div class="h-2 bg-gray-200 relative">
      <div class="top-0 left-0 h-full bg-black" :style="{width: `${100*(value+1) / max}%`}"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    max: Number
  }
}
</script>

<style>

</style>